<header #header class="ax-translateition-all ax-sticky ax-top-0 ax-z-10 ax-bg-surface"
  [ngClass]="{ 'sticky-state': HeaderType === 'child' }">

  <!-- حالت دسکتاپ -->
  <div class="ax-container ax-m-auto ax-flex ax-h-16 ax-items-center ax-justify-between sm:ax-h-16">
    <div class="ax-flex ax-cursor-pointer ax-items-center ax-gap-2 ax-text-sm" (click)="goToUrl()">
      <!-- وایت لیبل -->
      <img src="{{ env }}/{{ settingData.logo }}" [alt]="settingData.pageTitle" class="ax-h-12 ax-object-contain" />
      <!-- <ng-container *ngIf="HeaderType === 'main'; else elseSingleTemplate">
          <h1 class="ax-hidden sm:ax-block">{{ settingData.slogan }}</h1>
        </ng-container>
        <ng-template #elseSingleTemplate>
          <p class="ax-hidden sm:ax-block">{{ settingData.slogan }}</p>
        </ng-template> -->
      <div class="max-[900px]:ax-hidden"></div>
    </div>
    <!-- <div>
        <ax-menu oriatation="horizontal" dir="rtl">
          <ax-menu-item text="{{ 'home.reserveHotel' | translate | async }}" [routerLink]="['/hotels/', 'هتل']"></ax-menu-item>
          <ax-menu-item text="{{ 'footer.contactUs' | translate | async }}" [routerLink]="['contact']"></ax-menu-item>
          <ax-menu-item [text]="'footer.aboutUs' | translate | async" [routerLink]="['about-us']"></ax-menu-item>
          <ax-menu-item text="{{ 'footer.termsAndConditions' | translate | async }}" [routerLink]="['policy']"></ax-menu-item>
        </ax-menu>
      </div> -->
    <div class="ax-flex ax-gap-2">
      <!-- انتخاب زبان -->
      <ax-button class="ax-sm sm:ax-md">
        <ax-dropdown-panel>
          <ax-button-item-list (onItemClick)="_handleOnItemClick($event)">
            <ax-button-item *ngFor="let language of languageList" [text]="language.title" [name]="language.code">
            </ax-button-item>
          </ax-button-item-list>
        </ax-dropdown-panel>
        <ax-suffix>
          {{selectedLanguage ? selectedLanguage : language}}
          <!-- <ax-icon class="fa-regular fa-globe"></ax-icon> -->
        </ax-suffix>
      </ax-button>

      <ax-button look="blank" [color]="themeService.themeMode === 'light' ? 'ghost' : 'warning'"
        (onClick)="themeService.switchMode()" class="ax-sm sm:ax-md ax-hidden sm:ax-block">
        <ax-icon>
          <i class="fa-solid fa-brightness" *ngIf="themeService.themeMode === 'dark'"></i>
          <i class="fa-solid fa-moon" *ngIf="themeService.themeMode === 'light'"></i>
        </ax-icon>
      </ax-button>
      <ax-button [text]="!isMobile ? (userProfile.firstName ? userProfile.firstName : userProfile.username) : ''"
        *ngIf="userProfile" class="ax-sm sm:ax-md ax-hidden sm:ax-block" look="outline" color="primary"
        (onClick)="_handleOnItemClick({ name: 'account' })">
        <ax-dropdown-panel *ngIf="!this.isMobile">
          <ax-button-item-list (onItemClick)="_handleOnItemClick($event)">
            <!-- مشاهده حساب کاربری -->
            <ax-button-item [text]="('header.account' | translate | async)!" name="profile">
              <ax-prefix>
                <i class="fa-solid fa-user"></i>
              </ax-prefix>
            </ax-button-item>
            <!-- لیست رزرو ها -->
            <ax-button-item [text]="('header.reservationsList' | translate | async)!" name="reserve-list">
              <ax-prefix>
                <i class="fa-solid fa-file-lines"></i>
              </ax-prefix>
            </ax-button-item>
            <!-- خروج از حساب کاربری -->
            <ax-button-item [text]="('header.logout' | translate | async)!" color="danger" name="logout">
              <ax-prefix>
                <i class="fa-solid fa-right-from-bracket"></i>
              </ax-prefix>
            </ax-button-item>
          </ax-button-item-list>
        </ax-dropdown-panel>

        <ax-suffix>
          <ax-icon class="fa-solid fa-angle-down" *ngIf="!isMobile"></ax-icon>
          <ax-icon class="fa-solid fa-user" *ngIf="isMobile"></ax-icon>
        </ax-suffix>
      </ax-button>
      <!-- ورود / ثبت‌نام -->
      <ax-button
        [text]="isMobile ? '' : ('header.login' | translate | async) + '/' + ('header.register' | translate | async)"
        color="primary" (onClick)="loginPopup()" *ngIf="!userProfile" class="ax-sm sm:ax-md ax-hidden sm:ax-block">
        <ax-suffix *ngIf="isMobile"> <i class="fa-solid fa-right-to-bracket"></i> </ax-suffix></ax-button>
      <!-- پشتیبانی -->
      <a href="tel:{{ settingData.supportMobile }}">
        <ax-button [text]="isMobile ? '' : ('header.support' | translate | async)" look="blank"
          class="ax-sm sm:ax-md ax-hidden sm:ax-block">
          <ax-suffix *ngIf="isMobile">
            <ax-icon class="fa-solid fa-phone-volume"></ax-icon>
          </ax-suffix>
        </ax-button>
      </a>

      <ax-button color="primary" look="twotone" (onClick)="handleHamburgerClick()" class="ax-block sm:ax-hidden">
        <ax-icon>
          <i class="fa-solid fa-bars"></i>
        </ax-icon></ax-button>

      <!-- <ax-button look="blank" [text]="language == '' ? 'en' : 'fa'" look="ghost" (onClick)="changeLanguage()"
          class="ax-sm sm:ax-md">
        </ax-button> -->

    </div>
  </div>


</header>